import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    messageModal: {
        entity: null,
        entity_type: null,
        context: null,
        active: false,
        isReminder: true,
        closable: true,
        locService: null
    },
    isRouteKeyForced: false
};

export default {mutations, actions, state}
